import React, { memo } from 'react'
import { ALLIN_COLORS, cards, matrix } from './utils'

const ChartGrid = memo(
  ({
    matrixActions,
    style,
    isSweeper = false,
    hand,
    completedHands = [],
    isGameOverMode,
    mistakenHands = [],
    showRanges = true,
    showOutRange,
    isChartStatsMode = false,
    colors,
    gridWidth,
  }) => {

    const cellWidth = gridWidth / 14 || 35
    const chartWidth = `${cellWidth * 13 + 26}px`

    const column = new Array(13).fill()
    const row = new Array(13).fill()
    const data = Object.values(matrixActions).map((item) => item)

    const getLeftPosition = (index, col_index, row_index) => {
      let left = 0
      for (let i = 0; i < index; i++) {
        left +=
          cellWidth * parseFloat(data[i][matrix[`${col_index} ${row_index}`]])
      }
      return left
    }

    const completedHandsArr = Object.keys(completedHands).map((item) => {
      const [card1, card2] = item.split(',')
      return `${card1} ${card2}`
    })

    const mistakenHandsArr = Object.keys(mistakenHands).map((item) => {
      const [card1, card2] = item.split(',')
      return `${card1} ${card2}`
    })

    const getCellColor = ({ range, col_index, row_index }) => {
      if (
        isSweeper &&
        (isGameOverMode || !showOutRange) &&
        !completedHandsArr.includes(`${col_index} ${row_index}`)
      ) {
        if (hand && `${hand[0]} ${hand[1]}` === `${col_index} ${row_index}`)
          return 'orange'
        return 'transparent'
      }

      if (isSweeper) {
        if (hand && `${hand[0]} ${hand[1]}` === `${col_index} ${row_index}`)
          return 'orange'
        if (!showRanges) {
          if (completedHandsArr.includes(`${col_index} ${row_index}`))
            return 'green'

          return 'grey'
        } else {
          if (!completedHandsArr.includes(`${col_index} ${row_index}`))
            return 'grey'
        }
      }
      const availableActions = Object.keys(matrixActions)

      const chartColors = colors.light

      if (ALLIN_COLORS.includes(range.toUpperCase())) return chartColors['allin']

      if (
        availableActions.includes('Fold') ||
        availableActions.includes('FOLD')
      ) {
        switch (range.toUpperCase()) {
          case 'OOR':
            return chartColors['oor']
          case 'FOLD':
            return chartColors['fold']
          case 'RAISE':
          case '3-BET':
          case '4-BET':
          case '5-BET':
            return chartColors['raise']
          case 'CALL':
          case 'LIMP':
            return chartColors['call']
          default:
            return chartColors['raise']
        }
      } else {
        switch (range.toUpperCase()) {
          case 'OOR':
            return chartColors['fold']

          case 'RAISE':
          case '3-BET':
          case '4-BET':
          case '5-BET':
            return chartColors['raise']
          case 'CALL':
          case 'LIMP':
            return chartColors['call']
          case ALLIN_COLORS.includes(range.toUpperCase()):
            return chartColors['allin']
          default:
            return chartColors['raise']
        }
      }
    }

    const getCellTextColor = (col_index, row_index) => {
      return 'white'
    }

    let mistakesNumberObject = {}
    let completedNumberObject = {}
    if (isChartStatsMode) {
      mistakesNumberObject = mistakenHands
      completedNumberObject = completedHands
    }

    const CellStats = ({ row, col }) => {
      const getCompletedCount = () => {
        const value = completedNumberObject[`${col},${row}`]
        return value || ''
      }

      const getMistakesCount = () => {
        const value = mistakesNumberObject[`${col},${row}`]
        if (value) return value
        if (completedNumberObject[`${col},${row}`]) return 0
        return ''
      }

      const completedCount = getCompletedCount()
      const mistakesCount = getMistakesCount()
      let successCount  = completedCount - mistakesCount;
      if (successCount === 0 && !mistakesCount) successCount = ''

      const accuracy = Math.round(
        (successCount / (successCount + mistakesCount)) * 100,
      )

      const accuracyString = successCount || mistakesCount ? `${accuracy}%` : ''

      return (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: 'space-between',
            zIndex: 6,
          }}
        >
          <div
            style={{
              fontSize: '10px',
              textAlign: 'center',
            }}
          >
            {accuracyString}
          </div>
          <div
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              margin: 1,
              marginBottom: -2,
              display: 'flex'
            }}
          >
            <div
              style={{
                fontSize: '10px',
                color: 'green',
              }}
            >
              {successCount}
            </div>
            <div
              style={{
                fontSize: '10px',
                color: 'red',
              }}
            >
              {mistakesCount}
            </div>
          </div>
        </div>
      )
    }

    return (
      <>
        <div style={{ marginHorizontal: '6px', ...style }}>
          {row.map((row, row_index) => (
            <div
              key={row_index}
              style={{
                display: 'flex',
                opacity: 1,
                flexDirection: 'row',
                alignSelf: 'center',
                backgroundColor: 'transparent',
                marginBottom: '3px',
                width: chartWidth,
                justifyContent: 'space-between',
                position: 'relative',
              }}
            >
              {column.map((item, col_index) => (
                <div
                  className="ClearTheCharts__chart-cell-background"
                  key={col_index}
                  style={{
                    minWidth: cellWidth,
                    maxWidth: cellWidth,
                    height: cellWidth,
                    boxSizing: 'border-box',
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    borderRadius: 2,
                    overflow: 'hidden',
                    borderStyle: 'solid',
                    borderWidth: mistakenHandsArr.includes(
                      `${col_index} ${row_index}`,
                    )
                      ? 1
                      : 0,
                    borderColor: 'red',
                    position: 'relative',
                  }}
                >
                  {isChartStatsMode && (
                    <CellStats row={row_index} col={col_index} />
                  )}

                  {Object.keys(matrixActions).map((range, index) => {
                    if (range.toLowerCase() === 'oor') return null
                    const data = matrixActions[range]
                    const left = getLeftPosition(index, col_index, row_index)
                    if (!data[matrix[`${col_index} ${row_index}`]]) return null
                    return (
                      <div
                        key={index}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left,
                          opacity: 1,
                          backgroundColor: getCellColor({
                            range,
                            col_index,
                            row_index,
                          }),
                          width:
                            cellWidth *
                            data[matrix[`${col_index} ${row_index}`]],
                          height: cellWidth,
                          zIndex: 5,
                        }}
                      />
                    )
                  })}
                  {col_index > row_index ? (
                    <>
                      <div
                        style={{
                          textAlign: 'center',
                          letterSpacing: -0.8,
                          fontSize: '12px',
                          color: getCellTextColor(col_index, row_index),
                          zIndex: 8,
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translateX(-50%) translateY(-50%)',
                        }}
                      >
                        {cards[row_index]}
                        {cards[col_index]}s
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          textAlign: 'center',
                          letterSpacing: col_index < row_index ? -0.8 : 0,
                          fontSize: '12px',
                          color: getCellTextColor(col_index, row_index),
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translateX(-50%) translateY(-50%)',
                          zIndex: 6,
                        }}
                      >
                        {cards[col_index]}
                        {cards[row_index]}
                        {col_index < row_index && 'o'}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </>
    )
  },
)

export default ChartGrid
